import React, { useContext, useEffect, useState } from 'react'
import classNames from 'classnames'
import btnDeleted from '../../assets/btnDeleted.svg'
import UserContext from 'contexts/UserContext'
import { deleteBeneficary } from 'requests/benificary'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import BGModal from  '../../assets/modalBG.svg'

interface Props {
  isOpen: boolean
  closeModal: () => void
  idBnf: any
  isModalOpenDelete: boolean
  setBeneficiaryData: any
  isAdded?: boolean
  setIsAdded: () => void
}

const ModalDeleteBeneficiary: React.FC<Props> = ({
  isOpen,
  closeModal,
  idBnf,
  isModalOpenDelete,
  setBeneficiaryData,
  isAdded,
  setIsAdded,
}) => {
  if (!isOpen) return null
  const { user } = useContext(UserContext)
  const { TransferData, setTransferData } = useContext(transferBeneficiaryContext)

  const deleteBeneficiaryFunction = async () => {
    const id = user?.user?._id
    const token = user?.token?.accessToken
    
    try {
      const response = await deleteBeneficary(id, token, idBnf)
      if (response?.success) {
        if (TransferData?.idBeneficiary === idBnf) {
          setTransferData({
            ...TransferData,
            BeneficiaryName: '',
            idBeneficiary: '',
          })
        }
        if (setIsAdded) {
          setIsAdded()
        }
      }
      closeModal()
    } catch (error) {
      console.error(error)
    }
  }


  return (
    <div>
      {isModalOpenDelete && (
        <div
          className={classNames(
            'fixed flex flex-col justify-center place-items-center inset-0 z-50 bg-[#4945c12f] backdrop-blur-sm',
          )}
        >
          <img
            className=" w-24 h-24 -mb-[30px] object-cover rounded-full shadow-xl border-white border-[5px]"
            src={btnDeleted}
            alt="Person Image"
          />
          <img className='relative' src={BGModal} width={327} height={78} alt=''/>

            <div className="px-5 pb-5 rounded-b-[16px] flex flex-col text-center bg-[#FFF] w-[327px]">
              <div className="font-bold text-[19px] text-[#1D3A70] ">Confirmez-vous la suppression ?</div>
              <div className="text-[14px] font-normal text-[#6B7280] mt-5">
                Si vous confirmez, ce bénéficiaire sera définitivement supprimé.
              </div>
              
              <div className="flex justify-around mt-8">

                 <button className="text-white text-[16px] font-semibold w-[105px] h-[56px]   bg-[#5754E5] rounded-xl" onClick={closeModal}>
                  Annuler
                </button>
                <button
                  className="text-white text-[16px] font-semibold  bg-[#EE443F] w-[135px] h-[56px] rounded-xl"
                  onClick={deleteBeneficiaryFunction}
                >
                  Je confirme
                </button>
               
              </div>
            </div>
         
        </div>
      )}
    </div>
  )
}

export default ModalDeleteBeneficiary
